function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "phone-24px");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Contact-Notes-&-History",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "ADv2_ContactNotes_Recognised-Caller",
  transform: "translate(-1373.000000, -282.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-9",
  transform: "translate(821.000000, 249.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group",
  transform: "translate(550.000000, 11.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "phone-24px",
  transform: "translate(0.000000, 20.000000)"
}, /*#__PURE__*/React.createElement("polygon", {
  id: "Path",
  points: "0 0 20 0 20 20 0 20"
}), /*#__PURE__*/React.createElement("path", {
  d: "M5.51666667,8.99166667 C6.71666667,11.35 8.65,13.275 11.0083333,14.4833333 L12.8416667,12.65 C13.0666667,12.425 13.4,12.35 13.6916667,12.45 C14.625,12.7583333 15.6333333,12.925 16.6666667,12.925 C17.125,12.925 17.5,13.3 17.5,13.7583333 L17.5,16.6666667 C17.5,17.125 17.125,17.5 16.6666667,17.5 C8.84166667,17.5 2.5,11.1583333 2.5,3.33333333 C2.5,2.875 2.875,2.5 3.33333333,2.5 L6.25,2.5 C6.70833333,2.5 7.08333333,2.875 7.08333333,3.33333333 C7.08333333,4.375 7.25,5.375 7.55833333,6.30833333 C7.65,6.6 7.58333333,6.925 7.35,7.15833333 L5.51666667,8.99166667 Z",
  id: "Path",
  fill: "#001529",
  fillRule: "nonzero"
}))))));

var SvgPhone = function SvgPhone(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPhone, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/phone.3e819af7.svg";
export { ForwardRef as ReactComponent };